// extracted by mini-css-extract-plugin
module.exports = {"layout":"AlertToUseDesktop_layout__1ehu8"};